import { GridInputValue } from '../../types/types';
import { isValidLayoutHexColor } from './isValidLayoutHexColor';
import { LAYOUT_HEX_COLOR_FIELDS } from '../../constants';

type LayoutFieldRule = {
  // Field names the rule applies to.
  fields: string[];
  isValid: (value: GridInputValue) => boolean;
  // Translation key of the error shown under the input.
  errorKey: string;
};

// Client-side validation rules for layout form fields — extend by adding a rule.
const LAYOUT_FIELD_RULES: LayoutFieldRule[] = [
  {
    fields: LAYOUT_HEX_COLOR_FIELDS,
    isValid: isValidLayoutHexColor,
    errorKey: 'errors.invalidColor',
  },
];

// Returns the error translation key when the value is invalid, null when valid.
export const validateLayoutFieldValue = (
  name: string,
  value: GridInputValue
): string | null => {
  // Empty = unassigned (the API sends e.g. an unset color as "") — only a
  // filled-in value can be invalid.
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const failedRule = LAYOUT_FIELD_RULES.find(
    (rule) => rule.fields.includes(name) && !rule.isValid(value)
  );

  return failedRule?.errorKey ?? null;
};
